module.exports = __webpack_public_path__ + "static/media/lightning-bolt.001cd80f.svg";